import * as React from "react";

const IconReturn: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="13" height="11" viewBox="0 0 13 11" fill="currentColor"><polygon fill="currentColor" points="11.405 9.155 11.405 9.53 12.155 9.53 12.155 9.155 12.155 3.53 12.155 3.155 11.78 3.155 1.434 3.155 3.795 .795 4.059 .53 3.53 0 3.265 .265 .265 3.265 0 3.53 .265 3.795 3.265 6.795 3.53 7.059 4.059 6.53 3.795 6.265 1.434 3.905 11.405 3.905"  transform="translate(.845 .97)"/></svg>;
};

export default React.memo(IconReturn);
